import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import UserCard, {
	UserPreviewInfo,
} from "../../../../components/essentials/user-card/UserCard";
import { selectUser } from "../../../../core/auth/authSlice";
import { FollowApiRoutes } from "../../../../shared/api-routes/member/follow-api.routes";
import { User } from "../../../../shared/models";
import http from "../../../../shared/utils/http";
import "./FollowersModal.scss";

export interface FollowersModalProps {
	user_id: string;
}

const FollowersModal: React.FC<FollowersModalProps> = ({ user_id }) => {
	const [followers, setFollowers] = useState<UserPreviewInfo[]>([]);

	const { userId } = useSelector(selectUser) as User;
	useEffect(() => {
		http.get(FollowApiRoutes.GET_USER_FOLLOWERS(user_id)).then((res) => {
			setFollowers(res);
		});
	}, [user_id]);

	return (
		<div className="like-modal">
			{followers.map((user, index) => {
				return (
					<div key={index}>
						{index > 0 ? <div className="divider" /> : ""}
						<UserCard
							action={user.id !== userId ? "follow" : null}
							className="liker-card"
							userInfo={user}
						/>
					</div>
				);
			})}
		</div>
	);
};

export default FollowersModal;
